export default {
  getAll: {
    url: '/api/role/getAll',
    method: 'get'
  },
  create: {
    url: '/api/role/create',
    method: 'post'
  },
  update: {
    url: '/api/role/update',
    method: 'put'
  },
  delete: {
    url: '/api/role/delete',
    method: 'delete'
  }
}



// WEBPACK FOOTER //
// ./src/api/role.js